jQuery(document).ready(function ($) {

	//HABILITAR TOOLTIPS
	$(function () {
		$('[data-toggle="tooltip"]').tooltip()
	})

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//UNIDADES
	$('.lista-estados a').click(function(e) {
		e.preventDefault();

		var classe = $(this).attr('data-estado');

		$('.lista-estados a').removeClass('btn-secondary').addClass('btn-primary');
		$(this).addClass('btn-secondary');

		if(classe == 'todos') {
			$('.estado-container').removeClass('d-none');
		} else {
			$('.estado-container').addClass('d-none');
			$('.estado-'+classe).removeClass('d-none');
		}
	});

	//DETALHES DOS FRETES
	$('.frete-container').click(function (e) {
		$(this).addClass('clicked');
		$(this).tooltip('dispose');
		$(this).find('.info').removeClass('d-none');
	});

	//CARROSSEIS
	$('.clientes-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:true,
		autoplayTimeout:4000,
		dots:true,
		lazyLoad: true,
		navText:["&nbsp;","&nbsp;"],
		nav:false,
		responsive:{
			0:{
				items:2
			},
			600:{
				items:3
			},
			1000:{
				items:6
			}
		}
	});

	$('.seminovos-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:5000,
		dots:true,
		lazyLoad: true,
		navText:["&nbsp;","&nbsp;"],
		nav:false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

});

window.onscroll = function() { fixHeader() };
const header = document.getElementById("topo");
function fixHeader() {
	if (window.pageYOffset > 1) {
		header.classList.add("scrooled");
	} else {
		header.classList.remove("scrooled");
	}
}